import { fetcher } from 'services/helpers/responseHandler'

const getPreferences = async () => await fetcher.get('users/alerts/configuration')

const putPreferences = async data => await fetcher.put('users/alerts/configuration', data)

const get = async () => await fetcher.get('users/alerts')

const notificationsApi = {
  getPreferences,
  putPreferences,
  get
}

export default notificationsApi
